import styled from 'styled-components';

export const Container = styled.section`
  padding: 5rem 2rem;
  background-color: #ffffff;
`;

export const ContentWrapper = styled.div`
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  
  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 3rem;
  }
`;

export const LeftColumn = styled.div`
  flex: 1;
  padding-right: 3rem;
  
  @media (max-width: 1024px) {
    padding-right: 0;
  }
`;

export const RightColumn = styled.div`
  flex: 1.5;
`;

export const Title = styled.h2`
  font-size: 2.5rem;
  color: #272643;
  margin-bottom: 2rem;
  font-weight: 700;
  text-align: left;
`;

export const ContactInfo = styled.div`
  margin-bottom: 2rem;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

export const ContactText = styled.span`
  font-size: 1.1rem;
  color: #555;
`;

export const Description = styled.p`
  font-size: 1.1rem;
  color: #4D4D4D;
  line-height: 1.6;
`;

export const IconImageWhatsApp = styled.img`
  width: 60px;
  height: 60px;

  @media (max-width: 768px) {
    width: 56px;
    height: 56px;
  }
`;

export const IconImageEmail = styled.img`
  width: 50px;
  height: 50px;

  @media (max-width: 768px) {
    width: 47px;
    height: 47px;
  }
`;

export const ContactForm = styled.form`
  width: 100%;
`;

export const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

export const Label = styled.label`
  display: block;
  font-size: 1rem;
  font-weight: 500;
  color: #555;
  margin-bottom: 0.5rem;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.8rem;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  
  &:focus {
    outline: none;
    border-color: #2563EB;
  }
  
  &::placeholder {
    color: #aaa;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 0.8rem;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #2563EB;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const Checkbox = styled.input`
  margin-right: 0.5rem;
  cursor: pointer;
`;

export const CheckboxLabel = styled.label`
  font-size: 0.95rem;
  color: #555;
  cursor: pointer;
`;

export const SubmitButton = styled.button`
  background-color: #10B981;
  color: white;
  padding: 0.8rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #0e996b;
  }
`;
